import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Tooltip } from "antd";
import {
  LabelDataHeading,
  ValueDataHeading,
  ContentDivider,
  CustomizedIcon,
  GeminiName,
  UnderlyingContent,
} from "../../../style";
import { addressFormat } from "../../../utils";
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";

export const savedCharityRender = ({ data, savedGeminiModal, removedGeminiModal }) => {
  if (data.loading) {
    return <CustomizedIcon type="star" />;
  }
  return data.isSelected ? (
    <CustomizedIcon
      data-test = 'saved-charity'
      type="star"
      theme="filled"
      onClick={() => savedGeminiModal(data)}
    />
  ) : (
    <CustomizedIcon
      data-test="saved-charity-not-selected"
      type="star"
      theme="outlined"
      onClick={() => removedGeminiModal(data)}
    />
  );
};

export default function SearchGeminiCard({
  data,
  pendingCharityHandler,
  savedGeminiModal,
  removedGeminiModal,
  activityBlocked = "",
}) {
  return (
    <div>
      <Row type="flex">
        <Col span={2}>
          {savedCharityRender({ data, savedGeminiModal, removedGeminiModal })}
        </Col>
        <Col span={22}>
          <GeminiName>{data.legalName} </GeminiName>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={12}>
          <LabelDataHeading>EIN</LabelDataHeading>
          <ValueDataHeading>{data.ein}</ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHeading>Address</LabelDataHeading>
          <Tooltip
            placement="bottom"
            title={addressFormat({
              addressLine1: data.addressLine1,
              addressLine2: data.addressLine2,
              addressLine3: data.addressLine3,
              city: data.city,
              state: data.state,
              zipCode: data.zip,
            })}
          >
            <UnderlyingContent>
              {data.city + "," + data.state}
            </UnderlyingContent>
          </Tooltip>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={23}>
          <LabelDataHeading>Interest Area</LabelDataHeading>
          <ValueDataHeading>{data.interestArea}</ValueDataHeading>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={8}>
          <CapsuleButton
            data-test="card-gemini"
            onClick={() => pendingCharityHandler(data)}
            disabled={!!activityBlocked || data.loading}
            title={activityBlocked}
            text="Select"
            whiteBackground
            iconType="arrowRight"
          />
        </Col>
        <Col span={16}></Col>
      </Row>
    </div>
  );
}

SearchGeminiCard.propTypes = {
  data: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string,
    charityContactFirstName: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    ein: PropTypes.string,
    granteeOrg: PropTypes.any,
    interestArea: PropTypes.string,
    isSelected: PropTypes.bool,
    legalName: PropTypes.string,
    state: PropTypes.string,
    Type: PropTypes.any,
    zip: PropTypes.string,
  }),
  pendingCharityHandler: PropTypes.func,
  savedGeminiModal: PropTypes.func,
  removedGeminiModal: PropTypes.func,
  activityBlocked: PropTypes.string,
};
